module.exports = __webpack_public_path__ + "vendors/three.min.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=vendors/three.min.js!./src/vendors/three.min.js
// module id = 2501
// module chunks = 0